import { Pipe } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'datumZeit'
})
export class DatumZeitPipe extends DatePipe {
  transform(value: string): any {
    if (!value) {
      return '';
    }
    if (value.endsWith('00:00:00')) {
      return super.transform(value, 'dd.MM.yyyy', '', 'de-CH');
    }
    return super.transform(value, 'dd.MM.yyyy HH:mm', '', 'de-CH').replace('00:00', '');
  }
}
